import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import { connect } from 'react-redux';
import CancelButton from '../atoms/CancelButton';
import ConfirmButton from '../atoms/ConfirmButton';
import BackButton from '../atoms/BackButton';
import RegisterButton from '../atoms/RegisterButton';
import RequiredButton from '../atoms/RequiredButton';

const styles = {
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  description: {
    display: 'block',
    fontSize: 18,
    marginBottom: 20
  },
  fs14: {
    fontSize: 14
  },
  radioGroup: {
    marginBottom: 10
  },
  buttonContainer: {
    marginTop: 16
  },
  detailTable: {
    marginTop: 48
  },
  tableCell: {
    padding: '0 0 16px',
    border: 'none'
  },
  tableCellTitle: {
    width: 60
  },
  detailTableComfirm: {
    margin: '48px 0'
  },
  tableCellConfirm: {
    borderTop: '1px solid rgba(224, 224, 224, 1)',
    padding: '16px 12px'
  },
  tableCellTitleConfirm: {
    backgroundColor: '#F7F7F7',
    fontWeight: 700,
    width: 130
  }
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops
    }),
    () => ({})
  ),
  withState('allowMenuPriceGochiKid', 'setAllowMenuPriceGochiKid', 1),
  withState('isConfirm', 'setIsConfirm', false)
);

const button = enhance(
  ({
    classes,
    open,
    onClose,
    allowMenuPriceGochiKid,
    setAllowMenuPriceGochiKid,
    isConfirm,
    setIsConfirm,
    updateShopGochiKidMenuPrice
  }) => {
    useEffect(() => {
      if (open) {
        setIsConfirm(false);
        setAllowMenuPriceGochiKid(1);
      }
    }, [open]);

    return (
      <>
        <Modal open={open} onClose={onClose} className={classes.modal}>
          {!isConfirm ? (
            <div className={classes.contentContainer}>
              <Typography className={classes.title} variant="h6">
                こどもごちめし金額指定利用
              </Typography>
              <Table className={classes.detailTable}>
                <TableBody>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCell, classes.tableCellTitle]}
                    >
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormLabel className={classes.fs14}>
                        金額指定利用*
                      </FormLabel>
                      <RadioGroup
                        value={allowMenuPriceGochiKid}
                        onChange={e => {
                          setAllowMenuPriceGochiKid(
                            parseInt(e.target.value, 10)
                          );
                        }}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              利用する
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              利用しない
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <div className={classes.buttonContainer}>
                <CancelButton onClickAction={onClose} color="primary" />
                <ConfirmButton
                  onClickAction={() => {
                    setIsConfirm(true);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className={classes.contentContainer}>
              <Typography className={classes.title} variant="h6">
                こどもごちめし金額指定利用 確認
              </Typography>
              <Table className={classes.detailTableComfirm}>
                <TableBody>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellConfirm,
                        classes.tableCellTitleConfirm
                      ]}
                    >
                      金額指定利用
                    </TableCell>
                    <TableCell className={classes.tableCellConfirm}>
                      {allowMenuPriceGochiKid ? '利用する' : '利用しない'}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <div className={classes.buttonContainer}>
                <BackButton
                  onClickAction={() => {
                    setIsConfirm(false);
                  }}
                />
                <RegisterButton
                  onClickAction={() =>
                    updateShopGochiKidMenuPrice(allowMenuPriceGochiKid)
                  }
                />
              </div>
            </div>
          )}
        </Modal>
      </>
    );
  }
);

export default withStyles(styles)(button);
